export default __webpack_public_path__ + "static/media/DIY03.de41eca4.JPG";